import React, { useContext, useMemo, useState } from 'react';
import CardBox from '../../../CardBox';
import { Button, DatePicker, Empty } from '@maxtropy/components';
import { DoubleRightOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import ReactEcharts from 'echarts-for-react';
import { getChartOption } from './chart';
import { useRequest } from 'ahooks';
import { apiV2MicrogridOverviewGetOperatingPowerCurvePost } from '@maxtropy/intelligent-dispath-apis-v2';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { DatePickerProps, Space, Spin } from 'antd';
import PowerPredictionModal from './PowerPredictionModal';
import dayjs, { Dayjs } from 'dayjs';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';

const OperatingPowerCurve = () => {
  const { microgridId } = useContext(ShareDataContext);
  const [predictModalOpen, setPredictModalOpen] = useState<boolean>(false); // 查看预测弹窗
  const [date, setDate] = useState<Dayjs>(dayjs()); // 时间选择
  const hasPermission = useHasPermission(PermissionsType.B_POWERFORECAST); // 功率预测

  // 运行曲线
  const { data: chartsData, loading: chartsDataLoading } = useRequest(
    () => {
      return apiV2MicrogridOverviewGetOperatingPowerCurvePost({
        configId: microgridId,
        time: date.valueOf(),
      });
    },
    {
      ready: !!microgridId && !!date,
      refreshDeps: [microgridId, date],
      pollingInterval: 1000 * 60 * 15,
    }
  );

  // 图表
  const chartOption = useMemo(() => getChartOption(chartsData), [chartsData]);

  // 判断是否都为空，如果都为空则显示empty
  const isShowEmpty = useMemo(() => {
    if (chartsData?.list?.length) {
      return false;
    }
    return true;
  }, [chartsData]);

  const disabledDate: DatePickerProps['disabledDate'] = current => {
    return current && current > dayjs().endOf('day');
  };

  const onDateChange: DatePickerProps['onChange'] = date => {
    if (date) {
      setDate?.(date);
    }
  };

  return (
    <CardBox
      title="运行功率曲线"
      extraContent={
        <Space size={10}>
          <DatePicker
            style={{ width: 120 }}
            allowClear={false}
            disabledDate={disabledDate}
            onChange={onDateChange}
            picker="date"
            value={date}
            getPopupContainer={triggerNode => triggerNode}
          />
          {hasPermission && (
            <Button
              type="link"
              style={{ padding: '0' }}
              onClick={() => {
                setPredictModalOpen(true);
              }}
            >
              功率预测
              <DoubleRightOutlined className={styles.translationStyles} />
            </Button>
          )}
        </Space>
      }
    >
      {chartsDataLoading ? (
        <Spin spinning={true} />
      ) : isShowEmpty ? (
        <Empty className={styles.empty_box} />
      ) : (
        <ReactEcharts style={{ height: '100%' }} option={chartOption} notMerge lazyUpdate={false} />
      )}
      {predictModalOpen && (
        <PowerPredictionModal
          date={date}
          visible={predictModalOpen}
          onCancel={() => {
            setPredictModalOpen(false);
          }}
        />
      )}
    </CardBox>
  );
};

export default OperatingPowerCurve;
